import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import {withStyles} from '@material-ui/core';

import {getDirectionStyles} from '../../../../../../utils/ThemeUtils';

export const StyledInput = withStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        height: theme.spacing(8),
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: 'transparent',
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
        padding: theme.spacing(0, 2)
    }
}))(Paper);

export const StyledContainer = withStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.text.secondary,

        '& svg': {
            fill: theme.palette.text.secondary
        },

        '&:hover': {
            color: theme.palette.text.primary,
            '& svg': {
                fill: theme.palette.text.primary
            }
        }
    }
}))(Box);

export const StyledPaper = withStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'max-content',
        height: theme.spacing(6),
        fontSize: '0.75rem',
        padding: theme.spacing(0, 1.5),
        color: theme.palette.text.secondary,

        '& svg': {
            fill: theme.palette.text.secondary
        },

        '&:hover': {
            color: theme.palette.text.primary,
            '& svg': {
                fill: theme.palette.text.primary
            }
        }
    }
}))(Paper);

export const StyledChip = withStyles(theme => ({
    root: {
        border: `1px solid ${theme.palette.divider}`,
        color: theme.palette.divider,
        backgroundColor: 'transparent'
    }
}))(Chip);

export const StyledContentWrapper = withStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',

        margin: getDirectionStyles(theme.direction)(
            theme.spacing(0.5, 2, 0, 1),
            theme.spacing(0.5, 1, 0, 2)
        )
    }
}))(Box);

export const StyledIconWrapper = withStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',

        '& svg': {
            fill: theme.palette.text.primary
        }
    }
}))(Box);
